/* eslint-disable react/prop-types */
import React from "react";
import "../../assets/styles/App.css";
import "./ReportFormatModal.css";
import { Button } from "react-bootstrap";
import { withTranslation } from "react-i18next";
import { T_EXAMS } from "../../constants/translations";

const reportLayouts = [
  { id: "1x1", label: "1 x 1", rows: 1, cols: 1 },
  { id: "1x2", label: "1 x 2", rows: 1, cols: 2 },
  { id: "1x3", label: "1 x 3", rows: 1, cols: 3 },
  { id: "2x2", label: "2 x 2", rows: 2, cols: 2 }
];

/**
 * Modal that lets the user choose the InstaZ report grid layout (1x1 / 1x2 / 1x3 / 2x2)
 * and an optional patient-engagement QR code link, mirroring the InstaZ desktop app's
 * report-format selection. Calls onGenerate({ layout, qrCodeLink }) on confirm.
 *
 * @component
 */
class ReportFormatModal extends React.Component {
  constructor(props) {
    super(props);
    this.t = props.t;
    this.i18n = props.i18n;
    this.state = {
      selectedLayout: "1x1",
      qrCodeLink: ""
    };
    this.handleGenerate = this.handleGenerate.bind(this);
  }

  handleGenerate() {
    this.props.onGenerate({
      layout: this.state.selectedLayout,
      qrCodeLink: this.state.qrCodeLink.trim() || null
    });
  }

  renderLayoutPreview(layout) {
    const { rows, cols } = layout;
    const cellWidth = 100 / cols;
    const cellHeight = 100 / rows;
    const circleRadius = Math.min(cellWidth, cellHeight) * 0.35;

    const circlePositions = [];
    for (let row = 0; row < rows; row++) {
      for (let col = 0; col < cols; col++) {
        circlePositions.push({
          cx: (col + 0.5) * cellWidth,
          cy: (row + 0.5) * cellHeight,
          r: circleRadius
        });
      }
    }

    return (
      <svg
        viewBox="0 0 100 100"
        preserveAspectRatio="xMidYMid meet"
        className="report-format-preview-svg"
      >
        {circlePositions.map((pos, index) => (
          <circle
            key={index}
            cx={pos.cx}
            cy={pos.cy}
            r={pos.r}
            fill="#3fbe73"
          />
        ))}
      </svg>
    );
  }

  render() {
    return (
      <div className="custommodal">
        <div className="custommodalinner report-format-modal">
          <div className="loginpad">
            <h6 className="modal-heading">
              {this.t(T_EXAMS.examDetails.reportFormat.header)}
            </h6>
            <Button onClick={this.props.onClose} className="cancle">
              x
            </Button>
            <hr className="hrpadding" />
            <div className="firstpage">
              <label className="report-format-label">
                {this.t(T_EXAMS.examDetails.reportFormat.selectFormat)}
              </label>
              <div className="report-format-options-grid">
                {reportLayouts.map(layout => (
                  <div
                    key={layout.id}
                    className={
                      this.state.selectedLayout === layout.id
                        ? "report-format-option selected"
                        : "report-format-option"
                    }
                    onClick={() => this.setState({ selectedLayout: layout.id })}
                  >
                    <div className="report-format-option-preview">
                      {this.renderLayoutPreview(layout)}
                    </div>
                    <div className="report-format-option-radio">
                      <input
                        type="radio"
                        name="reportLayout"
                        id={`layout-${layout.id}`}
                        checked={this.state.selectedLayout === layout.id}
                        onChange={() =>
                          this.setState({ selectedLayout: layout.id })
                        }
                        onClick={e => e.stopPropagation()}
                      />
                      <label htmlFor={`layout-${layout.id}`}>
                        {layout.label}
                      </label>
                    </div>
                  </div>
                ))}
              </div>

              <label className="report-format-label report-format-qr-label">
                {this.t(T_EXAMS.examDetails.reportFormat.qrLabel)}{" "}
                <span className="report-format-optional">
                  {this.t(T_EXAMS.examDetails.reportFormat.optional)}
                </span>
              </label>
              <input
                type="url"
                className="report-format-qr-input"
                value={this.state.qrCodeLink}
                onChange={e => this.setState({ qrCodeLink: e.target.value })}
                placeholder={this.t(
                  T_EXAMS.examDetails.reportFormat.qrPlaceholder
                )}
              />

              <div className="report-format-actions">
                <Button
                  onClick={this.props.onClose}
                  className="loginbtn2 report-format-cancel"
                >
                  {this.t(T_EXAMS.examDetails.reportFormat.cancel)}
                </Button>
                <Button
                  onClick={this.handleGenerate}
                  className="loginbtn1 report-format-generate"
                >
                  {this.t(T_EXAMS.examDetails.reportFormat.generate)}
                </Button>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export default withTranslation()(ReportFormatModal);
